export enum StemSystemEnum {
    AvenirComplete = 'Avenir Complete',
    TaperlocComplete = 'Taperloc Complete',
    MS30 = 'MS-30',
    Z1 = 'Z1',
}

export const stemSystems = [
    {
        key: 'avenir-complete',
        label: StemSystemEnum.AvenirComplete,
    },
    {
        key: 'taperloc-complete',
        label: StemSystemEnum.TaperlocComplete,
    },
    {
        key: 'ms-30',
        label: StemSystemEnum.MS30,
    },
    {
        key: 'z1',
        label: StemSystemEnum.Z1,
    },
];

export const availableStemSystems = () => {
    return stemSystems;
};
